import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'estructura-organizacional/unidades-operativas/';

/**
 * GET unidades-operativas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getUnidadesOperativas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
    // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
